module.exports = __webpack_public_path__ + "static/media/mode19.d22a0d5b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode19.gif
// module id = 1335
// module chunks = 114